module.exports = __webpack_public_path__ + "static/media/video.213ac0af.mp4";